import { useMutation } from '@tanstack/react-query';
import ApprovalApi from 'apis/ApprovalApis';
import { useTitle } from 'contexts/TitleProvider';
import { IApprovalTable, IGetAllApproval } from 'interfaces/Approval';
import TableSetApproval from 'pages/System/SetApprovalPage/TableSetApproval';
import { useEffect, useState } from 'react';

const SetApprovalPage = () => {
  const { setTitle, setBreadcrumb } = useTitle();
  const [approvals, setApprovals] = useState<IApprovalTable>({
    items: [],
    pageInfo: {
      currentPage: 1,
      hasNextPage: false,
      hasPreviousPage: false,
      itemsPerPage: 10,
      totalItems: 0,
      totalPages: 0,
    },
  });
  const { isPending, mutate: getAllApproval } = useMutation({
    mutationFn: (params: IGetAllApproval) => ApprovalApi.getAllApproval(params),
    onSuccess: (data) => {
      setApprovals(data.data.getApproval);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    setTitle('Thiết lập quy trình ký duyệt');
    setBreadcrumb([
      { title: 'Hệ thống' },
      { title: 'Thiết lập quy trình ký duyệt' },
    ]);
  }, [setBreadcrumb, setTitle]);

  useEffect(() => {
    getAllApproval({
      skip: 0,
      take: 10,
      useYn: true,
    });
  }, [getAllApproval]);

  return (
    <>
      {/* <Row gutter={[8, 16]} align={'middle'} justify={'end'}>
        <Col>
          <ButtonFilter isOpen={isOpenFilter} setIsOpen={setIsOpenFilter} />
        </Col>
        <Col>
          <Button
            fill
            iconBefore={<PlusOutlined />}
            title="Tạo"
            handleOnclick={handleAdd}
          />
        </Col>
      </Row>
      {isOpenFilter && <FilterSetApproval />} */}
      <TableSetApproval data={approvals} isPending={isPending} />
    </>
  );
};

export default SetApprovalPage;
